/* 恵みの湯：左上の「メニュー（三）」を常に表示し、押すと左からメニューを開く（スマホ・PC共通）。
   メニューの中身はトップページの左サイドバー（hk_sidebar）と同じものを表示します。 */
(function () {
  var drawer = null;
  var lastFocus = null;

  function fallbackLinks() {
    var nav = document.getElementById('mobile-nav');
    if (!nav) return '';
    var html = '<div class="hk-drawer-fallback">';
    nav.querySelectorAll('a').forEach(function (a) { html += '<a href="' + a.getAttribute('href') + '">' + a.textContent + '</a>'; });
    return html + '</div>';
  }

  function putSidebar(body, root) {
    var inner = root.querySelector('.sidebar-inner');
    if (!inner) return false;
    body.innerHTML = '';
    root.querySelectorAll('style').forEach(function (s) { body.appendChild(s.cloneNode(true)); });
    var aside = document.createElement('div');
    aside.className = 'hk-side';
    aside.appendChild(inner.cloneNode(true));
    body.appendChild(aside);
    return true;
  }

  function build() {
    drawer = document.createElement('div');
    drawer.className = 'hk-drawer';
    drawer.id = 'hk-drawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML =
      '<div class="hk-drawer-overlay" data-hk-close></div>' +
      '<div class="hk-drawer-panel" role="dialog" aria-modal="true" aria-label="メニュー">' +
        '<div class="hk-drawer-head"><span>メニュー</span><button type="button" class="hk-drawer-close" data-hk-close>閉じる</button></div>' +
        '<div class="hk-drawer-account"></div>' +
        '<div class="hk-drawer-body"></div>' +
      '</div>';
    document.body.appendChild(drawer);

    var acc = document.querySelector('.hk-account');
    var accBox = drawer.querySelector('.hk-drawer-account');
    if (acc) accBox.innerHTML = acc.innerHTML; else accBox.remove();

    var body = drawer.querySelector('.hk-drawer-body');
    var side = document.getElementById('store-sidebar');
    if (side && putSidebar(body, side.parentNode || side)) {
      try { sessionStorage.setItem('mgHkSidebar', (side.parentNode || side).innerHTML); } catch (e) {}
    } else {
      body.innerHTML = fallbackLinks();
      var cached = null;
      try { cached = sessionStorage.getItem('mgHkSidebar'); } catch (e) {}
      var useHtml = function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return putSidebar(body, tmp);
      };
      if (!(cached && useHtml(cached))) {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (t) {
            if (!t) return;
            var d = new DOMParser().parseFromString(t, 'text/html');
            var s = d.getElementById('store-sidebar');
            if (!s) return;
            var html = (s.parentNode || s).innerHTML;
            if (useHtml(html)) { try { sessionStorage.setItem('mgHkSidebar', html); } catch (e) {} }
          })
          .catch(function () {});
      }
    }

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-hk-close]')) { close(); return; }
      if (e.target.closest('a')) close();
    });
  }

  function setExpanded(v) {
    document.querySelectorAll('.hk-menu-button,[data-hk-menu]').forEach(function (b) { b.setAttribute('aria-expanded', String(v)); });
  }

  function open() {
    if (!drawer) build();
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('hk-drawer-open');
    setExpanded(true);
    var c = drawer.querySelector('.hk-drawer-close');
    if (c) c.focus({ preventScroll: true });
  }

  function close() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('hk-drawer-open');
    setExpanded(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function init() {
    if (document.documentElement.dataset.mgHkMenu) return;
    document.documentElement.dataset.mgHkMenu = '1';
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.hk-menu-button,[data-hk-menu]');
      if (!b) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (drawer && drawer.classList.contains('is-open')) close(); else open();
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
